import { Get } from 'src/axios';
import { TRating } from 'src/types/rating';

export const getRatingOrganizationHome = () =>
  Get<TRating[]>('/team/rating_organization/');

export const getRatingOrganizationCompany = () =>
  Get<TRating[]>('/team/rating_organization_company/');
